import { useState } from "react";
import { ProviderIndexComponent } from "../components/providers/ProviderIndexComponent";
import { useFetchProviders } from "../hooks/providers/useFetchProviders";

export const ProvidersPage = () => {
  const [providersTableMeta, setProvidersTableMeta] = useState<any>({
    page: 1,
    limit: 10,
    search_value: "",
    _t: Date.now(),
  });
  const [searchText, setSearchText] = useState("");
  const [selectedRow, setSelectedRow] = useState<any>(null);

  const providersList = useFetchProviders(providersTableMeta);

  const onPaginationChange = (page: any) => {
    setProvidersTableMeta({ ...providersTableMeta, page: page });
  };

  const onSearchChange = (value: string) => {
    setSearchText(value);
    setProvidersTableMeta({ ...providersTableMeta, search_value: value, page: 1, _t: Date.now() });
  };

  const onRefresh = () => {
    setProvidersTableMeta({ ...providersTableMeta, _t: Date.now() });
  };

  const onSelectRow = (
    ids: Array<number>,
    records: Array<any>
  ) => {
    setSelectedRow(records[0]);
  };

  return (
    <ProviderIndexComponent
      providersList={providersList}
      onPaginationChange={onPaginationChange}
      searchText={searchText}
      onSearchChange={onSearchChange}
      onRefresh={onRefresh}
      selectedRow={selectedRow}
      onSelectRow={onSelectRow}
    />
  );
};
